import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SlickCarouselModule } from 'ngx-slick-carousel';

@Component({
    selector: 'app-home-whats-new',
    standalone: true,
    imports: [CommonModule, TranslateModule, SlickCarouselModule],
    templateUrl: './home-whats-new.component.html',
    styleUrl: './home-whats-new.component.scss',
})
export class HomeWhatsNewComponent {
    @Input() whatsNewData: any;
    @Output() whatsNewDetailsClick: any = new EventEmitter<any>();
    slideConfig = {
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: false,
        prevArrow:
            '<button class="slick-prev"><img src="/assets/images/home/left-arrow.png" alt="Previous" /></button>',
        nextArrow:
            '<button class="slick-next"><img src="/assets/images/home/right-arrow.png" alt="Next" /></button>',
        responsive: [
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    arrows: false,
                },
            },
        ],
    };

    whatsNewDetails(data: any) {
        this.whatsNewDetailsClick.emit(data);
    }

    removeHtmlTags(text: string): string {
        const doc = new DOMParser().parseFromString(text, 'text/html');
        return doc.body.textContent || '';
    }

    truncate(str: string, length: number): string {
        str = str || ''; // provide default value manually
        return str.length > length ? str.slice(0, length) : str;
    }
}
